// import TestCalendarTesting from './TestCalendarTesting';
// import Login from '../../../../modules/Login/LoginEvent'; // adjust path as needed
// import Teams from '../../../Tab';
// import Web from '../../../Tab1';

// const msHomeAccountId = sessionStorage.getItem('msHomeAccountId');

// export default function CalendarEntryPoint(props) {
//   console.log("msHomeAccountId in CalendarEntryPoint:", msHomeAccountId);
//   if (msHomeAccountId) {
//     return <Teams {...props} />;
//   } else {
//     return <Web />;
//   }
// }

import * as microsoftTeams from "@microsoft/teams-js";
import { useEffect, useState } from "react";

import Teams from "./TeamsTab";
import Web from "./WebTab";
import { Toaster } from 'react-hot-toast';
import Responsive from "../modules/Responsive/Responsive";
import { initFormSuccessHandler } from "../assets/demo/js/custom-script";
import { Login } from "../modules/apiUtils";
import {
  CALENDAR_ENTRY_SOURCE,
  setCalendarEntrySource,
} from "../modules/Calendar/Calendar/calendarEntrySource";
import {
  DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY,
  DELETE_ACCOUNT_STORAGE_KEY,
} from "../modules/DeleteAccount/DeleteAccount.jsx";
import Logo from "../assets/images/logo-big.svg";

export default function CalendarEntryPoint(props) {
  const [msHomeAccountId, setMsHomeAccountId] = useState(null);
  const [isTeams, setIsTeams] = useState(false);
  const [isTeamsLoginReady, setIsTeamsLoginReady] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const shouldBypassResponsiveBlocker =
    window.location.pathname === "/accountremove" ||
    localStorage.getItem(DELETE_ACCOUNT_RESPONSIVE_BYPASS_KEY) === "1";

  useEffect(() => {
    const cleanup = initFormSuccessHandler();

    return () => cleanup && cleanup();
  }, []);

  const getCalendarEntryErrorMessage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f7f8fa",
      }}
    >
      <div
        style={{
          maxWidth: "520px",
          width: "50%",
          textAlign: "center",
          background: "#ffffff",
          borderRadius: "20px",
          padding: "40px 32px",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.08)",
        }}
      >
        <img
          src={Logo}
          alt="Upgrade plan"
          style={{ width: "200px", height: "70px" }}
        />
        <p
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: 600,
            color: "#1f2937"
          }}
        >
          A paid service plan (or trial) is required to use this app, for more information visit the About tab. For support issues, see support information in the About tab.
        </p>
      </div>
    </div>
  );
};

  useEffect(() => {
    const init = async () => {
      let notifiedHost = false;
      try {
        const runningInIframe = window.self !== window.top;

        if (!runningInIframe) {
          setCalendarEntrySource(CALENDAR_ENTRY_SOURCE.WEB);
          setIsTeams(false);
          setIsLoading(false);
          return;
        }

        setCalendarEntrySource(CALENDAR_ENTRY_SOURCE.TEAMS);
        setIsTeams(true);
        await microsoftTeams.app.initialize();
        // Tell the Teams host the tab shell has loaded before running the slower
        // login/data calls. Without this signal the host keeps waiting and, if
        // login is slow (as on production), tears the tab down after ~50s with
        // "There was a problem reaching this app". Our own loading/error UI now
        // owns the login result instead of the host's load timeout.
        microsoftTeams.app.notifySuccess();
        notifiedHost = true;
        const context = await microsoftTeams.app.getContext();

        const accountId =
          context?.user?.id || context?.userObjectId;

        if (!accountId) {
          throw new Error("Microsoft Teams account ID not found");
        }

        sessionStorage.setItem("msHomeAccountId", accountId);

        console.log("Account ID in CalendarEntryPoint:", accountId);
        const loginResponse = await Login();

        if (!loginResponse || loginResponse.Data?.ResponseCode !== 200) {
          throw new Error("Unable to complete Teams login");
        }

        setMsHomeAccountId(accountId);
        setIsTeamsLoginReady(true);
      } catch (err) {
        console.error("Teams init failed:", err);
        // Only report failure to the host if we never signalled success (i.e. the
        // Teams SDK itself failed to initialize). Post-init failures (login/data)
        // are surfaced via the in-app error UI so the host keeps the tab mounted.
        if (!notifiedHost) {
          try {
            microsoftTeams.app.notifyFailure({
              reason: microsoftTeams.app.FailedReason.Other,
              message: err?.message,
            });
          } catch (notifyErr) {
            console.error("notifyFailure failed:", notifyErr);
          }
        }
        setError(getCalendarEntryErrorMessage());
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!isTeams) {
    return <div>
      <Toaster position="top-right" reverseOrder={false} />
      {/* <MyMapComponent /> */}
      <Web />
      {!shouldBypassResponsiveBlocker && <Responsive />}
    </div>
    // <Router>
    //  <ProtectedRoute>
    //  <Web />;
    // </ProtectedRoute>
    // </Router>
  }

  if (msHomeAccountId && isTeamsLoginReady) {
    return <Teams {...props} />;
  }
}
